import {
  CUSTOMER_MASTER_SUCCESS,
  CUSTOMER_MASTER_XREF_SUCCESS,
  CUSTOMER_MASTER_XREF_FIELDS_SUCCESS,
  CUSTOMER_MASTER_XREF_BY_ID_SUCCESS,
  MATERIAL_MASTER_SUCCESS,
  SUPPLIER_MASTER_SUCCESS,
  IMA_CONFIG_XREF_CUSTOMER_MASTER_SUCCESS,
  IMA_CONFIG_CUSTOMER_MASTER_SUCCESS,
  IMA_CONFIG_XREF_MATERIAL_MASTER_SUCCESS,
  MEMBERSHIP_SUCCESS,
  MEMBERSHIP_ROSTER_DETAILBYID_SUCCESS,
  UPLOAD_MEMBERSHIP_CUSTOMER_UPLOAD_SUCCESS,
  MASTER_REPORT_SUCCESS,
  MEMBERSHIP_DETAIL_SUCCESS,
  MEMBERSHIP_FORMAT_SUCCESS,
  MEMBERSHIP_FORMAT_FIELDS_SUCCESS,
  MEMBERSHIP_FORMAT_BY_ID_SUCCESS,
  MEMBERSHIP_UPLOAD_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_FORMAT_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_FORMAT_FIELDS_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_FORMAT_BY_ID_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_UPLOAD_SUCCESS,
  BOM_SUCCESS,
  BOM_DETAIL_SUCCESS,
  BOM_FORMAT_SUCCESS,
  SALES_BUNDLE_SUCCESS,
  BOM_FORMAT_FIELDS_SUCCESS,
  BOM_FORMAT_BY_ID_SUCCESS,
  BOM_UPLOAD_SUCCESS,
  EMPLOYEE_MASTER_SUCCESS,
  EMPLOYEE_MASTER_VIEW_DETAIL_SUCCESS,
  INTEGRATION_SETUP_SUCCESS,
  INTEGRATION_CONNECTION_DATA_SUCCESS,
  INTEGRATION_CONNECTION_DATA_NO_STATUS_SUCCESS,
  INTEGRATION_PROFILE_DATA_SUCCESS,
  INTEGRATION_STAGING_DATA_SUCCESS,
  SINGLE_INTEGRATION_CONNECTION_DATA_SUCCESS,
  TRACK_ACTIVITY_SUCCESS,
  FILTER_LIST_SUCCESS,
  FILTER_LIST_FAIL,
  FILTER_BY_ID_LIST_SUCCESS,
  INTEGRATION_BY_ID_SUCCESS,
  TERRITORY_SUCCESS,
  FETCH_START,
  FETCH_END,
  FETCH_START1,
  FETCH_END1,
  APPROVAL_DESIGNER_GET_SUCCESS,
  APPROVAL_DESIGNER_DETAIL_SUCCESS,
  CONTRACT_DEFAULT_DESIGNER_SUCCESS,
  CONTRACT_DEFAULT_DETAIL_SUCCESS,
  PAYMENT_DESIGNER_GET_SUCCESS,
  ACCRUAL_DESIGNER_GET_SUCCESS,
  ACCRUAL_DESIGNER_SINGLE_SUCCESS,
  PAYMENT_DESIGNER_SINGLE_SUCCESS,
  SALES_BASIS_ALL,
  SALES_BASIS_SINGLE,
  BATCH_JOB_ALL,
  BATCH_JOB_DETAIL,
  BATCH_JOB_STATUS,
  BATCH_JOB_REPORT,
  BATCH_JOB_REPORT_EXECUTION_LOG,
  BATCH_JOB_CONFIGURATION,
  BATCH_JOB_SCHEDULE,
  BATCH_JOB_STATUS_SECOND_PAGE,
  BATCH_JOB_STATUS_SINGLE_DATA,
  PRICING_BATCH_JOB_ALL,
  PRICING_BATCH_JOB_DETAIL,
  EXCEPTION_MANAGEMENT_ALL,
  EXCEPTION_MANAGEMENT_SINGLE,
  EXCEPTION_MANAGEMENT_VIEW_DETAIL_SUCCESS,
  EXCEPTION_MANAGEMENT_TIER_EVALS,
  WORKFLOW_ANCHORS,
  PRODUCT_GROUP_SUCCESS,
  PRODUCT_GROUP_SINGLE_SUCCESS,
  PRODUCT_GROUP_FORMAT_SUCCESS,
  PRODUCT_GROUP_FORMAT_FIELDS_SUCCESS,
  PRODUCT_GROUP_FORMAT_BY_ID_SUCCESS,
  PRODUCT_GROUP_UPLOAD_SUCCESS,
  GENERAL_UOM,
  CONVERSION_SUCCESS,
  TERRITORY_LIST_SUCCESS,
  TERRITORY_SINGLE_SUCCESS,
  INTEGRATION_MAPPING_SUCCESS,
  INTEGRATION_QUALIFIERS_SUCCESS,
  INTEGRATION_CONFIGURATION_SUCCESS,
  NEW_INTEGRATION_MAPPING_SUCCESS,
  NEW_INTEGRATION_MAPPINGS_DATA_BY_ID,
  INTEGRATION_QUALIFIERS_FUNCTIONALITY_SUCCESS,
  INTEGRATION_QUALIFIERS_TABLE_NAME_SUCCESS,
  INTEGRATION_QUALIFIERS_DATA_BY_ID,
  INTEGRATION_LIST_DATA_SUCCESS,
  INTEGRATION_LIST_DATA_BY_ID,
  INTEGRATION_MAPPING_BY_ID,
  INTEGRATION_MAPPING_FIELDS,
  MAPPING_CREATE_SUCCESS,
  INTEGRATION_LOAD_FREQUENCY,
  INTEGRATION_ACTIVITY,
  INTEGRATION_DATA_SOURCE,
  IM_HISTORY_SUCCESS,
  BATCH_INTEGRATION_JOB_ALL,
  BATCH_INTEGRATION_JOB_STATUS,
  FECTCH_INTEGRATION_SETUP_SUCCESS,
  MEMBERSHIP_HIERARCHY_SUCCESS,
  SALES_COMMISSION_CONFIG_SUCCESS,
  SC_TRACK_AND_TRACE_DATA_SUCCESS,
  SC_BASE_CONFIG_DATA_SUCCESS,
  CHANGE_LOG_DATA_SUCCESS,
  SC_TRACK_AND_TRACE_LOG_DATA_SUCCESS,
  SC_TRACK_AND_TRACE_LOG_DATA_CLEAR,
  PRICING_LOGS_BY_ID_SUCCESS,
  SALES_COMMISSION_CONFIG_DETAILBYID_SUCCESS,
  MEMBERSHIP_CONTRACT_XREF_SUCCESS,
  MEMBERSHIP_CONTRACT_XREF_BY_ID,
  MEMBERSHIP_CONTRACT_GROUP_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_BY_ID,
  GPO_ADDRESS_SEARCH_SUCCESS,
  TIER_ACTI_ADDRESS_SEARCH_SUCCESS,
  MASS_MEMBERSHIP_UPDATE,
  MASS_MEBERSHIP_UPDATE_ACTION,
  WORK_FLOW_ASSIGNMENTS_SUCCESS,
  WORK_FLOW_ASSIGNMENTS_DETAIL_SUCCESS,
  UPLOAD_INTEGRATION_FILE,
  DEFAULT_DESIGNER_CONFIG_SUCCESS,
  GET_ACQUIRE_DATA_SUCCESS,
  GET_ACQUIRE_DATA_CLEAR,
  SEARCH_SUPPLIER_NUMBER_SUCCESS,
} from '../../../actions/Customers/AddCustomers/ActionTypes';
import { uploadIntegrationFile } from '../../../actions/Customers/AddCustomers/AuthAction';

const initialState = {
  customerMasterData: [],
  customerMasterXRefData: [],
  customerMasterXRefFormatFieldData: [],
  customerMasterXRefFormatDataById: {},
  materialMasterData: [],
  supplierMasterData: [],
  dropdownData: [],
  dropdownDataCustomer: [],
  membershipData: [],
  membershipRosterDataById: [],
  membershipCustomerUploadData: [],
  masterReportData: [],
  membershipDetailsData: [],
  membershipFormatData: [],
  membershipFormatFieldData: [],
  membershipFormatDataById: {},
  membership: [],
  membershipErrorList: [],
  membershipContractGroupFormatData: [],
  membershipContractGroupFormatFieldData: [],
  membershipContractGroupFormatDataById: {},
  membershipContractGroupErrorList: [],
  bomData: [],
  bomDetailsData: [],
  bomFormatData: [],
  bomFormatFieldData: [],
  bompFormatDataById: {},
  bomErrorList: [],
  employeeMasterData: [],
  employeeMasterViewData: [],
  integrationSetupData: [],
  integrationStagingData: [],
  integrationProfilesData: [],
  integrationConnectionData: [],
  integrationConnectionDataNoStatus: [],
  singleIntegrationConnectionData: [],
  trackActivityData: [],
  statusLoader: false,
  filterNameList: [],
  filterNameById: [],
  integrationByIdData: {},
  territoryData: [],
  loading: false,
  loading1: false,
  approvalDesignerGetAll: [],
  contractDefaultDesignerGetAll: [],
  contractDefaultDetail: [],
  paymentDesignerGetAll: [],
  accrualDesignerGetAll: [],
  accrualDesignerSingle: [],
  paymentDesignerSingle: [],
  salesBasusAll: [],
  batchJobAll: [],
  salesBasisSingle: {},
  batchJobDetail: {},
  exceptionManagementAl: [],
  workflowAnchors: [],
  batchJobStatus: [],
  batchJobReport: [],
  batchJobReportExecutionLog: [],
  batchJobConfiguration: [],
  batchJobSchedules: [],
  batchJobStatusSecondPage: [],
  batchJobStatusSingleDataList: [],
  productGroupdata: [],
  productGroupSingleData: [],
  productGroupFormatData: [],
  productGroupFormatFieldData: [],
  productGroupSingleFormatData: [],
  productGroupErrorList: [],
  generalUOMAll: [],
  currencyData: [],
  territoryList: [],
  territorySingleData: [],
  currencyData: [],
  integrationMappingData: [],
  integrationQualifiersData: [],
  integrationListData: [],
  newIntegrationMappingData: [],
  newIntegrationMappingDataById: [],
  integrationQualifiersFunctionalityData: [],
  integrationQualifiersTableNameData: [],
  integrationQualifiersDataByID: [],
  integrationListDataByID: [],
  integrationMappingSingleData: [],
  integrationMappingFields: [],
  savedMapData: [],
  frequencyList: [],
  dataSourceList: [],
  activityList: [],
  imHistoryData: {},
  integrationbatchJobAll: [],
  integrationBatchJobStatus: [],
  fetchIntegrationSetupData: [],
  membershipHierarchyData: [],
  salesCommissionConfigData: [],
  scTrackAndTraceData: [],
  scBaseConfigData: [],
  changeLogResultData: [],
  scTrackAndTraceLogData: [],
  salesCommissionConfigDetailByIdData: [],
  pricingBatchJobAll: [],
  pricingBatchJobDetail: [],
  membershipContractXREFData: [],
  membershipContractXREFSingleData: [],
  membershipContractGroupData: [],
  membershipContractGroupSingleData: [],
  salesBundleData: [],
  gpoAddressSearchData: [],
  tierActivationAddressSearchData: [],
  exceptionManagementTierEvals: [],
  membershipMassUpdate: [],
  membershipMassUpdateAction: [],
  exceptionManagementViews: [],
  workFlowAssignmentsGetAll: [],
  workFlowAssignmentsDetail: [],
  uploadIntegrationFile: [],
  defaultDesignerConfig: [],
  acquireData: []
};

const AddCustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case FETCH_START1:
      return {
        ...state,
        loading1: true,
      };
    case FETCH_END1:
      return {
        ...state,
        loading1: false,
      };
    case CUSTOMER_MASTER_SUCCESS:
      return {
        ...state,
        customerMasterData: action.data,
      };
    case CUSTOMER_MASTER_XREF_SUCCESS:
      return {
        ...state,
        customerMasterXRefData: action.data,
      };
    case CUSTOMER_MASTER_XREF_FIELDS_SUCCESS:
      return {
        ...state,
        customerMasterXRefFormatFieldData: action.data,
      };
    case CUSTOMER_MASTER_XREF_BY_ID_SUCCESS: {
      return {
        ...state,
        customerMasterXRefFormatDataById: action.data,
      };
    }
    case MATERIAL_MASTER_SUCCESS:
      return {
        ...state,
        materialMasterData: action.data,
      };
    case SUPPLIER_MASTER_SUCCESS:
      return {
        ...state,
        supplierMasterData: action.data,
      };
    case IMA_CONFIG_XREF_CUSTOMER_MASTER_SUCCESS:
      return {
        ...state,
        dropdownData: action.data,
      };
    case IMA_CONFIG_CUSTOMER_MASTER_SUCCESS:
      return {
        ...state,
        dropdownDataCustomer: action.data,
      };
    case IMA_CONFIG_XREF_MATERIAL_MASTER_SUCCESS:
      return {
        ...state,
        dropdownDataMaterialXRef: action.data,
      };
    case MEMBERSHIP_SUCCESS:
      return {
        ...state,
        membershipData: action.data,
      };
    case MEMBERSHIP_ROSTER_DETAILBYID_SUCCESS:
      return {
        ...state,
        membershipRosterDataById: action.data,
      };
    case UPLOAD_MEMBERSHIP_CUSTOMER_UPLOAD_SUCCESS:
      return {
        ...state,
        membershipCustomerUploadData: action.data,
      };
    case MASTER_REPORT_SUCCESS:
      return {
        ...state,
        masterReportData: action.data,
      };
    case MEMBERSHIP_DETAIL_SUCCESS:
      return {
        ...state,
        membershipDetailsData: action.data,
      };
    case MEMBERSHIP_FORMAT_SUCCESS:
      return {
        ...state,
        membershipFormatData: action.data,
      };
    case MEMBERSHIP_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        membershipFormatFieldData: action.data,
      };
    case MEMBERSHIP_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        membershipFormatDataById: action.data,
      };
    case MEMBERSHIP_UPLOAD_SUCCESS:
      return {
        ...state,
        membershipErrorList: action.data,
      };
    case MEMBERSHIP_CONTRACT_GROUP_FORMAT_SUCCESS:
      return {
        ...state,
        membershipContractGroupFormatData: action.data,
      };
    case MEMBERSHIP_CONTRACT_GROUP_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        membershipContractGroupFormatFieldData: action.data,
      };
    case MEMBERSHIP_CONTRACT_GROUP_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        membershipContractGroupFormatDataById: action.data,
      };
    case MEMBERSHIP_CONTRACT_GROUP_UPLOAD_SUCCESS:
      return {
        ...state,
        membershipContractGroupErrorList: action.data,
      };
    case BOM_SUCCESS:
      return {
        ...state,
        bomData: action.data,
      };
    case BOM_DETAIL_SUCCESS:
      return {
        ...state,
        bomDetailsData: action.data,
      };
    case BOM_FORMAT_SUCCESS:
      return {
        ...state,
        bomFormatData: action.data,
      };
    case BOM_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        bomFormatFieldData: action.data,
      };
    case BOM_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        bompFormatDataById: action.data,
      };
    case BOM_UPLOAD_SUCCESS:
      return {
        ...state,
        bomErrorList: action.data,
      };
    case EMPLOYEE_MASTER_SUCCESS:
      return {
        ...state,
        employeeMasterData: action.data,
      };
    case EMPLOYEE_MASTER_VIEW_DETAIL_SUCCESS:
      return {
        ...state,
        employeeMasterViewData: action.data,
      };
    case INTEGRATION_SETUP_SUCCESS:
      return {
        ...state,
        integrationSetupData: action.data,
      };
    case INTEGRATION_STAGING_DATA_SUCCESS:
      return {
        ...state,
        integrationStagingData: action.data,
      };
    case INTEGRATION_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        integrationProfilesData: action.data,
      };
    case INTEGRATION_CONNECTION_DATA_SUCCESS:
      return {
        ...state,
        integrationConnectionData: action.data,
        statusLoader: action.loader,
      };
    case INTEGRATION_CONNECTION_DATA_NO_STATUS_SUCCESS:
      return {
        ...state,
        integrationConnectionDataNoStatus: action.data,
      };
    case SINGLE_INTEGRATION_CONNECTION_DATA_SUCCESS:
      return {
        ...state,
        singleIntegrationConnectionData: action.data,
      };
    case TRACK_ACTIVITY_SUCCESS:
      return {
        ...state,
        trackActivityData: action.data,
      };
    case FILTER_LIST_SUCCESS: {
      return {
        ...state,
        filterNameList: action.data,
      };
    }
    case FILTER_LIST_FAIL: {
      return {
        ...state,
      };
    }
    case INTEGRATION_BY_ID_SUCCESS: {
      return {
        ...state,
        integrationByIdData: action.data,
      };
    }
    case FILTER_BY_ID_LIST_SUCCESS: {
      return {
        ...state,
        filterNameById: action.data,
      };
    }
    case TERRITORY_SUCCESS:
      return {
        ...state,
        territoryData: action.data,
      };
    case APPROVAL_DESIGNER_GET_SUCCESS:
      return {
        ...state,
        approvalDesignerGetAll: action.data,
      };
    case APPROVAL_DESIGNER_DETAIL_SUCCESS:
      return {
        ...state,
        approvalDesignerGetDetail: action.data,
      };
    case CONTRACT_DEFAULT_DESIGNER_SUCCESS:
      return {
        ...state,
        contractDefaultDesignerGetAll: action.data,
      };
    case CONTRACT_DEFAULT_DETAIL_SUCCESS:
      return {
        ...state,
        contractDefaultDetail: action.data,
      };
    case PAYMENT_DESIGNER_GET_SUCCESS:
      return {
        ...state,
        paymentDesignerGetAll: action.data,
      };
    case ACCRUAL_DESIGNER_GET_SUCCESS:
      return {
        ...state,
        accrualDesignerGetAll: action.data,
      };
    case ACCRUAL_DESIGNER_SINGLE_SUCCESS:
      return {
        ...state,
        accrualDesignerSingle: action.data,
      };
    case PAYMENT_DESIGNER_SINGLE_SUCCESS:
      return {
        ...state,
        paymentDesignerSingle: action.data,
      };
    case SALES_BASIS_ALL:
      return {
        ...state,
        salesBasisAll: action.data,
      };
    case SALES_BASIS_SINGLE:
      return {
        ...state,
        salesBasisSingle: action.data,
      };
    case BATCH_JOB_ALL:
      return {
        ...state,
        batchJobAll: action.data,
      };
    case BATCH_JOB_DETAIL:
      return {
        ...state,
        batchJobDetail: action.data,
      };
    case PRICING_BATCH_JOB_ALL:
      return {
        ...state,
        pricingBatchJobAll: action.data,
      };
    case PRICING_BATCH_JOB_DETAIL:
      return {
        ...state,
        pricingBatchJobDetail: action.data,
      };
    case EXCEPTION_MANAGEMENT_ALL:
      return {
        ...state,
        exceptionManagementAll: action.data,
      };
    case EXCEPTION_MANAGEMENT_SINGLE:
      return {
        ...state,
        exceptionManagementSingle: action.data,
      };
    case EXCEPTION_MANAGEMENT_VIEW_DETAIL_SUCCESS:
      return {
        ...state,
        exceptionManagementViews: action.data,
      };
    case EXCEPTION_MANAGEMENT_TIER_EVALS:
      return {
        ...state,
        exceptionManagementTierEvals: action.data,
      };
    case WORKFLOW_ANCHORS:
      return {
        ...state,
        workflowAnchors: action.data,
      };
    case BATCH_JOB_STATUS:
      return {
        ...state,
        batchJobStatus: action.data,
      };
    case BATCH_JOB_REPORT:
      return {
        ...state,
        batchJobReport: action.data,
      };
    case BATCH_JOB_REPORT_EXECUTION_LOG:
      return {
        ...state,
        batchJobReportExecutionLog: action.data,
      };
    case BATCH_JOB_CONFIGURATION:
      return {
        ...state,
        batchJobConfiguration: action.data,
      };
    case BATCH_JOB_SCHEDULE:
      return {
        ...state,
        batchJobSchedules: action.data,
      };
    case BATCH_JOB_STATUS_SECOND_PAGE:
      return {
        ...state,
        batchJobStatusSecondPage: action.data,
      };
    case BATCH_JOB_STATUS_SINGLE_DATA:
      return {
        ...state,
        batchJobStatusSingleDataList: action.data,
      };
    case PRODUCT_GROUP_SUCCESS:
      return {
        ...state,
        productGroupData: action.data,
      };
    case PRODUCT_GROUP_SINGLE_SUCCESS:
      return {
        ...state,
        productGroupSingleData: action.data,
      };
    case PRODUCT_GROUP_FORMAT_SUCCESS:
      return {
        ...state,
        productGroupFormatData: action.data,
      };
    case PRODUCT_GROUP_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        productGroupFormatFieldData: action.data,
      };
    case PRODUCT_GROUP_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        productGroupSingleFormatData: action.data,
      };
    case PRODUCT_GROUP_UPLOAD_SUCCESS:
      return {
        ...state,
        productGroupErrorList: action.data,
      };
    case GENERAL_UOM:
      return {
        ...state,
        generalUOMAll: action.data,
      };
    case CONVERSION_SUCCESS:
      return {
        ...state,
        currencyData: action.data,
      };
    case TERRITORY_LIST_SUCCESS:
      return {
        ...state,
        territoryList: action.data,
      };
    case TERRITORY_SINGLE_SUCCESS:
      return {
        ...state,
        territorySingleData: action.data,
      };
    case INTEGRATION_MAPPING_SUCCESS:
      return {
        ...state,
        integrationMappingData: action.data,
      };
    case INTEGRATION_QUALIFIERS_SUCCESS:
      return {
        ...state,
        integrationQualifiersData: action.data,
      };
    case INTEGRATION_CONFIGURATION_SUCCESS:
      return {
        ...state,
        integrationConfigurationData: action.data,
      };
    case INTEGRATION_LIST_DATA_SUCCESS:
      return {
        ...state,
        integrationListData: action.data,
      };
    case NEW_INTEGRATION_MAPPING_SUCCESS:
      return {
        ...state,
        newIntegrationMappingData: action.data,
      };
    case NEW_INTEGRATION_MAPPINGS_DATA_BY_ID:
      return {
        ...state,
        newIntegrationMappingDataById: action.data,
      };
    case INTEGRATION_QUALIFIERS_FUNCTIONALITY_SUCCESS:
      return {
        ...state,
        integrationQualifiersFunctionalityData: action.data,
      };
    case INTEGRATION_QUALIFIERS_TABLE_NAME_SUCCESS:
      return {
        ...state,
        integrationQualifiersTableNameData: action.data,
      };
    case INTEGRATION_QUALIFIERS_DATA_BY_ID:
      return {
        ...state,
        integrationQualifiersDataByID: action.data,
      };
    case INTEGRATION_LIST_DATA_BY_ID:
      return {
        ...state,
        integrationListDataByID: action.data,
      };
    case INTEGRATION_MAPPING_BY_ID:
      return {
        ...state,
        integrationMappingSingleData: action.data,
      };
    case INTEGRATION_MAPPING_FIELDS:
      return {
        ...state,
        integrationMappingFields: action.data,
      };
    case MAPPING_CREATE_SUCCESS:
      return {
        ...state,
        savedMapData: action.data,
      };
    case INTEGRATION_LOAD_FREQUENCY:
      return {
        ...state,
        frequencyList: action.data,
      };
    case INTEGRATION_DATA_SOURCE:
      return {
        ...state,
        dataSourceList: action.data,
      };
    case INTEGRATION_ACTIVITY:
      return {
        ...state,
        activityList: action.data,
      };
    case IM_HISTORY_SUCCESS:
      return {
        ...state,
        imHistoryData: action.data,
      };
    case BATCH_INTEGRATION_JOB_ALL:
      return {
        ...state,
        integrationbatchJobAll: action.data,
      };
    case BATCH_INTEGRATION_JOB_STATUS:
      return {
        ...state,
        integrationBatchJobStatus: action.data,
      };
    case FECTCH_INTEGRATION_SETUP_SUCCESS:
      return {
        ...state,
        fetchIntegrationSetupData: action.data,
      };
    case MEMBERSHIP_HIERARCHY_SUCCESS:
      return {
        ...state,
        membershipHierarchyData: action.data,
      };
    case SALES_COMMISSION_CONFIG_SUCCESS:
      return {
        ...state,
        salesCommissionConfigData: action.data,
      };
    case SC_TRACK_AND_TRACE_DATA_SUCCESS:
      return {
        ...state,
        scTrackAndTraceData: action.data,
      };
    case SC_BASE_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        scBaseConfigData: action.data,
      };
    case CHANGE_LOG_DATA_SUCCESS:
      return {
        ...state,
        changeLogResultData: action.data,
      };
    case SC_TRACK_AND_TRACE_LOG_DATA_SUCCESS:
      return {
        ...state,
        scTrackAndTraceLogData: action.data,
      };
    case SC_TRACK_AND_TRACE_LOG_DATA_CLEAR:
      return {
        ...state,
        scTrackAndTraceLogData: [],
      };
    case PRICING_LOGS_BY_ID_SUCCESS:
      return {
        ...state,
        pricingLogsData: action.data,
      };
    case SALES_COMMISSION_CONFIG_DETAILBYID_SUCCESS:
      return {
        ...state,
        salesCommissionConfigDetailByIdData: action.data,
      };
    case SALES_BUNDLE_SUCCESS:
      return {
        ...state,
        salesBundleData: action.data,
      };
    case MEMBERSHIP_CONTRACT_XREF_SUCCESS:
      return {
        ...state,
        membershipContractXREFData: action.data,
      };
    case MEMBERSHIP_CONTRACT_XREF_BY_ID:
      return {
        ...state,
        membershipContractXREFSingleData: action.data,
      };
    case MEMBERSHIP_CONTRACT_GROUP_SUCCESS:
      return {
        ...state,
        membershipContractGroupData: action.data,
      };
    case MEMBERSHIP_CONTRACT_GROUP_BY_ID:
      return {
        ...state,
        membershipContractGroupSingleData: action.data,
      };
    case GPO_ADDRESS_SEARCH_SUCCESS:
      return {
        ...state,
        gpoAddressSearchData: action.data,
      };
    case TIER_ACTI_ADDRESS_SEARCH_SUCCESS:
      return {
        ...state,
        tierActivationAddressSearchData: action.data,
      };
    case MASS_MEMBERSHIP_UPDATE:
      return {
        ...state,
        membershipMassUpdate: action.data,
      };
    case MASS_MEBERSHIP_UPDATE_ACTION:
      return {
        ...state,
        membershipMassUpdateAction: action.data,
      };
    case WORK_FLOW_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        workFlowAssignmentsGetAll: action.data,
      };
    case WORK_FLOW_ASSIGNMENTS_DETAIL_SUCCESS:
      return {
        ...state,
        workFlowAssignmentsDetail: action.data,
      };
    case DEFAULT_DESIGNER_CONFIG_SUCCESS:
      return {
        ...state,
        defaultDesignerConfig: action.data,
      };
    case GET_ACQUIRE_DATA_SUCCESS: {
      return {
        ...state,
        acquireData: action.data
      }
    };
    case GET_ACQUIRE_DATA_CLEAR: {
      return {
        ...state,
        acquireData: []
      }
    };
    case SEARCH_SUPPLIER_NUMBER_SUCCESS: {
      return {
        ...state,
        supplierNumberSearchData: action.data
      }
    }
    default:
      return state;
  }
};

export default AddCustomerReducer;
